<ion-card class="ion-no-margin">
  <ion-card-header>
    <div class="card-title">
      <div class="card-title-icon">
        <ion-icon name="book" size="small"/>
      </div>
      <ion-text color="dark">
        <h3 class="ion-no-margin">{{ article.title }}</h3>
      </ion-text>
    </div>
  </ion-card-header>
  <div class="divider"></div>
  @if (!loading) {
    <ion-card-content>
      <app-shared-user-html [html]="article.content"/>
    </ion-card-content>
  } @else {
    <div class="ion-text-center">
      <ion-spinner class="ion-margin"/>
    </div>
  }

  @if (article.attachments?.length) {
    <ng-container class="ion-no-margin ion-margin-top">
      <ion-card-header>
        <div class="card-title">
          <div class="card-title-icon">
            <ion-icon name="attach-outline" size="small"/>
          </div>
          <ion-text color="dark">
            <h3 class="ion-no-margin">{{ "COMPONENTS.ATTACHMENTS.FILES.LABEL" | translate }}</h3>
          </ion-text>
        </div>
      </ion-card-header>
      <div class="divider"></div>
      <ion-card-content>
        <app-shared-attachments [attachmentsOrga]="article.attachments" [hasHeader]="false" [lines]="'none'"/>
      </ion-card-content>
    </ng-container>
  }
</ion-card>

